import { dlog } from "@shared/utility.js";
import { notificationCenter } from "@shared/NotificationCenter.js";
import { Notifications } from "@shared/Notifications.js";

// Special case for strangely chosen price lookup SKU #s
const FALLBACK_PRICE_SKUS = {
    "grip-adhesive": "101999-B0001",
    "grip-poptop": "12345678910",
};

class PriceLookup {
    constructor() {
        this.priceMap = new Map();
        this.priceEndpointCallback = null;
    }

    setPriceEndpoint(callback) {
        this.priceEndpointCallback = callback;
    }

    async fetchPrices(productSKUs) {
        if (!this.priceEndpointCallback || !productSKUs || productSKUs.length === 0) {
            console.error("PriceLookup: No price endpoint configured or no SKUs provided");
            return;
        }

        const skus = productSKUs.map(sku => sku.id);
        const fallbackSKUs = productSKUs.map(sku => FALLBACK_PRICE_SKUS[sku.productSubcategory]).filter(Boolean);
        const allSKUs = [...new Set([...skus, ...fallbackSKUs])];
        dlog(`PriceLookup: Fetching prices for ${allSKUs.length} SKUs: ${allSKUs.join(", ")}`);

        return new Promise((resolve, reject) => {
            try {
                dlog("PriceLookup: Calling priceEndpointCallback with", allSKUs.length, "SKUs");
                this.priceEndpointCallback(allSKUs, (response) => {
                    // dlog(`PriceLookup: response exists? ${!!response}`);
                    // dlog(`PriceLookup: response.productData exists? ${!!(response && response.productData)}`);
                    // dlog(`PriceLookup: response.productData is array? ${!!(response && response.productData && Array.isArray(response.productData))}`);

                    if (!response || !response.productData || !Array.isArray(response.productData)) {
                        console.error("PriceLookup: Invalid product data received");
                        resolve();
                        return;
                    }

                    const productData = response.productData;
                    dlog(`PriceLookup: rec'd ${productData.length} product data items`);
                    
                    const disabledInventory = response.disabledInventory || [];
                    dlog(`PriceLookup: rec'd ${disabledInventory.length} disabled inventory items`);

                    productData.forEach(item => {
                        if (item.productId && item.formattedPrice) {
                            this.priceMap.set(item.productId, item.formattedPrice);
                            dlog(`PriceLookup: ${item.productId} -> ${item.formattedPrice}`);
                        }
                    });

                    dlog(`PriceLookup: Loaded ${this.priceMap.size} total prices`);
                    notificationCenter.post(Notifications.pricingDidChange);
                    resolve(disabledInventory);
                });
            } catch (error) {
                console.error("PriceLookup: Error fetching prices:", error);
                reject(error);
            }
        });
    }

    getPrice(sku, fallbackPrice = null, subcategory = null) {
        const overrideSKU = FALLBACK_PRICE_SKUS[subcategory];
        if (overrideSKU && this.priceMap.has(overrideSKU)) {
            return this.priceMap.get(overrideSKU);
        }
        if (this.priceMap.has(sku)) {
            return this.priceMap.get(sku);
        }
        return fallbackPrice != null ? formatPrice(fallbackPrice) : null;
    }

    clear() {
        this.priceMap.clear();
    }
}

export const priceLookup = new PriceLookup();

export function formatPrice(price) {
    if (price == null || price === 0) {
        return "";
    }

    if (Number.isInteger(price)) {
        return `$${price}`;
    } else {
        return `$${price.toFixed(2)}`;
    }
}
